import { Card } from 'primereact/card';
import React from 'react';
import { withTranslation } from 'react-i18next';
import BaseContainer from '../baseContainers/BaseContainer';
import ActionButton from '../components/ActionButton';
import { CustomDialog } from '../components/CustomDialog';
import { CustomMessages } from '../components/CustomMessages';
import DivContainer from '../components/DivContainer';
import BlockUi from '../components/waitPanel/BlockUi';
import YesNoDialog from '../components/YesNoDialog';
import AccountService from '../services/AccountService';
import ProfileService from '../services/ProfileService';
import AdditionalToolsService from  '../services/AdditionalToolsService';
import { saveAs } from 'file-saver';
import ActionLink from '../components/ActionLink';
import ApprovalsAcceptationDialog from './ApprovalsAcceptationDialog';
import TooltipComponent from '../components/TooltipComponent';
import BannerComponent from '../components/BannerComponent';
import InputTextComponent from '../components/inputs/InputTextComponent';

class AdditionalServicesContainer extends BaseContainer {
    constructor(props) {
        super(props, new ProfileService());
        this.accountService = new AccountService();
        this.additionalService = new AdditionalToolsService();
        this.user = this.authService.getProfile();
        this.state = {
            loading: true,
            list: [],
            element: {},
            twoStepAuthChosen: '',
            activateDialogVisibile: false,
            deactivateDialogVisibile: false,
            trustedDevices: [],
            acceptedTerms: undefined,
            highwaysAgreementsDialogVisibile: false, 
            activateTooltipVisible: false,

        };
        this.handleOpenDialog = this.handleOpenDialog.bind(this);
        this.handleCloseDialog = this.handleCloseDialog.bind(this);
        this.handleActivateMotorwayPayments = this.handleActivateMotorwayPayments.bind(this);
        this.handleDeactivateMotorwayPayments = this.handleDeactivateMotorwayPayments.bind(this);
        this.handleActivateMotorwayPaymentsHide = this.handleActivateMotorwayPaymentsHide.bind(this);
        this.handleShowTooltip = this.handleShowTooltip.bind(this);
        this.handleHideTooltip = this.handleHideTooltip.bind(this);
   
    }


    componentDidMount() {
        const { t } = this.props;
        super.componentDidMount();
        this.refreshData();

        this.additionalService.getHighwayAllTerms()
        .then((res) => {
            this.setState({
                approvals : res,
            })
        })
        .catch((err) => {
            this.showErrorMessage(t('additionalServices.getTermsError'))
            
        })
        { this.checkIfDeviceAlreadyAddedToTrusted() }

        if (!(this.authService.getProfile().helpdeskUserRole === 'HELPDESK' ||
            this.authService.getProfile().helpdeskUserRole === 'REGIONAL_MANAGER' ||
            this.authService.getProfile().helpdeskUserRole === 'SALES_REPRESENTATIVE' ||
            this.authService.getProfile().helpdeskUserRole === 'HOTLINE')) {
            this.service
                .getTrustedDevices(this.user?.userAgreementMapId)
                .then((response) => {
                    this.setState({
                        trustedDevices: response.trustedDeviceList,
                    });
                })
                .catch(() => {
                    this.showErrorMessage(t('error.profileTrustedDevicesError'));
                })
        }

    }

    refreshData(){
        const {t} = this.props;
        this.additionalService.getHighwayPaymentInfo()
        .then((res) => {
            this.setState({
                approvalsToDisplay : res.acceptedApprovals,
                enabled: res.enabled,
                loading: false

            })
        })
        .catch((err) => {
            this.showErrorMessage(t('additionalServices.getDetailsError'))
        })
    }

    setElement() {
        const { t } = this.props;
        this.service
            .get()
            .then((element) => {
                this.updateElement(element);
            })
            .catch(() => {
                this.unblockUi();
                this.showErrorMessage(t('error.profile'));
            });
    }

    toTitleCase(str) {
        return str
            ? str
                .toLowerCase()
                .split(' ')
                .map((el) => el.charAt(0).toUpperCase() + el.substring(1))
                .join(' ')
            : str;
    }

    updateElement(element) {
        this.setState({ element }, () => this.unblockUi());
    }


    readMessage() {
        const messageFromStorage = this.readCookie(this.getContainerListName());
        if (messageFromStorage !== undefined && messageFromStorage != null) {
            const message = JSON.parse(messageFromStorage);
            this.removeCookie(this.getContainerListName());
            if (
                message.severity !== undefined &&
                message.severity != null &&
                message.summary !== undefined &&
                message.summary != null &&
                message.detail !== undefined &&
                message.detail != null
            ) {
                this.showMessage(message.severity, message.summary, message.detail);
            }
        }
    }
    getContainerListName() {
        return 'additional-services-container';
    }

    checkIfDeviceAlreadyAddedToTrusted() {
        const { t } = this.props;
        if (this.readCookie('startAfterLoginCookie') === 'true' && !(this.authService.getProfile().helpdeskUserRole === 'HELPDESK' ||
            this.authService.getProfile().helpdeskUserRole === 'REGIONAL_MANAGER' ||
            this.authService.getProfile().helpdeskUserRole === 'SALES_REPRESENTATIVE' ||
            this.authService.getProfile().helpdeskUserRole === 'HOTLINE')) {
            let currentDeviceIdent = this.authService.generateDeviceUuid();
            this.service.getTrustedDevices(this.user?.userAgreementMapId)
                .then((res) => {
                    if (res.trustedDeviceList.length > 0) {
                        if (res.trustedDeviceList.filter(d => d.deviceIdent === currentDeviceIdent).length > 0) {
                            console.log("Urzadzenie to jest na liście zaufanych. ")
                            this.setState({ addTrustedDeviceDialog: false });
                        }
                        else {
                            console.log("Urzadzenie to nie widnieje na liście zaufanych. ")
                            this.setState({ addTrustedDeviceDialog: true });
                        }
                    } else {
                        console.log("Urzadzenie to nie widnieje na liście zaufanych. ")
                        this.setState({ addTrustedDeviceDialog: true });
                    }
                })
                .catch(() => {
                    this.showErrorMessage(t('error.profileTrustedDevicesError'));
                })
        }

    }

    handleAddToTrustedDevice() {
        let generatedDeviceUuid = this.authService.generateDeviceUuid();
        this.service
            .addTrustedDevice(generatedDeviceUuid, this.user?.userAgreementMapId)
            .then((res) => {
                if (res === true) {
                    this.showSuccessMessage("Dodano urządzenie do zaufanych");
                    this.saveCookie('startAfterLoginCookie', false);
                    this.setState({ addTrustedDeviceDialog: false });
                }
                //this.refreshProfile();
            })
            .catch(() => {
                this.showErrorMessage("Nie udało się dodać urządzenia do zaufanych");
            });
    }

    renderAddToTrustedDevicesDialog() {
        let startAfterLoginCookie = false;
        if (!(this.authService.getProfile().helpdeskUserRole === 'HELPDESK' ||
            this.authService.getProfile().helpdeskUserRole === 'REGIONAL_MANAGER' ||
            this.authService.getProfile().helpdeskUserRole === 'SALES_REPRESENTATIVE' ||
            this.authService.getProfile().helpdeskUserRole === 'HOTLINE') &&
            this.readCookie('startAfterLoginCookie') === 'true') {
            startAfterLoginCookie = true;
        }
        return (
            this.state.addTrustedDeviceDialog && startAfterLoginCookie === true) && <CustomDialog
                name='add-trusted-dialog'
                className='add-trusted-device'
                header="Dodawanie urządzenia do zaufanych"
                visible={this.state.addTrustedDeviceDialog}
                viewMode={'VIEW'}
                onHide={() => {
                    //  this.authService.logout();
                    this.saveCookie('startAfterLoginCookie', false);
                    this.setState({
                        addTrustedDeviceDialog: false,

                    });
                }}
                closeable
            >
                <div className='codeDialog-text'>
                    <label>{"W przypadku dodania urządzenia do zaufanych podawanie kodu weryfikacyjnego przy kolejnych logowaniach nie będzie wymagane."} </label>
                </div>
                <div className='col-width-auto codeBtn'>
                    <ActionButton
                        label={"Dodaj"}
                        variant='blue'
                        // className='edit-blue-link'
                        handleClick={() => this.handleAddToTrustedDevice()}
                        disabled={this.state.captchaPreventAction}
                    />
                </div>

            </CustomDialog>
    }

    checkTokenIfAllHybridAgreementNotAccepted(){
        const listOfAcceptedTerms = this.authService.getHighwaysAcceptedTerms();
        return this.state.approvals.filter(el => !listOfAcceptedTerms.includes(el.petraAgreementId)).length > 0;

    }

    activateMotorwayPayments() { 
        const {t} = this.props;
        const {element} = this.state;
        this.blockUi();
            this.additionalService.highwayEnable(true)
            .then((response) => {
                if(response.res.result === true) {
                    this.refreshData();
                    this.showSuccessMessage(t('additionalServices.highwaysActivationSuccess'))
                    this.setState({activateDialogVisibile : false})
                 }
                  if(response.token){
                    this.authService.setToken(response.token);
                }
                this.unblockUi();
               

            })
            .catch((err) => {  
                if (err.errorCode === 'HIGHWAY_ACTIVATE_SAFO_VERIFICATION_ERROR' || err.errorCode === 'HIGHWAY_ACTIVATE_CARD_PROCESSING_ERROR') {
                    this.showErrorMessage(err.message);
                } else {
                    this.showErrorMessage(t('error.highwaysCustomerActivationError'))
                }
                this.unblockUi();

            })

    } 
    dectivateMotorwayPayments() { 
        const {element} = this.state;
        const {t} = this.props;
        this.blockUi();
            this.additionalService.highwayEnable(false)
            .then((response) => {
                if(response.res.result === true) {
                    this.showSuccessMessage(t('additionalServices.highwaysDeactivationSuccess'))
                    this.setState({deactivateDialogVisibile : false})
                   
                }
                if(response.token){
                    this.authService.setToken(response.token);
                }
                this.refreshData();
                this.unblockUi();

            })
            .catch((err) => {   
                if (err.errorCode === 'HIGHWAY_DEACTIVATE_SAFO_VERIFICATION_ERROR' || err.errorCode === 'HIGHWAY_DEACTIVATE_CARD_PROCESSING_ERROR') {
                    this.showErrorMessage(err.message);
                } else {
                    this.showErrorMessage(t('error.highwaysCustomerDeactivationError'))
                }
                this.unblockUi();
            })

    } 
    handleHybridAgreementDialogClose(callback) {
        if(this.checkTokenIfAllHybridAgreementNotAccepted() === false){
            this.setState({activateDialogVisibile: true, highwaysAgreementsDialogVisibile : false}, () => {
                if (callback) {
                    callback();
                }
            });
        } else {
            this.setState({activateDialogVisibile: false, highwaysAgreementsDialogVisibile : false}, () => {
                if (callback) {
                    callback();
                }
            });
        }
      
    }
    renderActivateDialogContent() {
        const {t} = this.props;
        let part1 = t('additionalServices.activationConfirmation'); 
        let part2 = t('additionalServices.activationInformation');
        return <div> {part1}  <br /> <span style={{ fontSize: 'smaller', fontStyle: 'italic' }}><br />{part2}</span> </div>
    }

    renderDeactivateDialogContent() {
        const {t} = this.props;
        let part1 = t('additionalServices.deactivationConfirmation');
        let part2 = t('additionalServices.deactivationInformation');
        return <div> {part1}  <br /> {part2}</div>
    }

    render() {
        const { t } = this.props;
        const allApprovalsHaveLinkUrl = this.state.approvals?.every(approval =>  approval.contents?.some(el => el.type === "LINK" && el.linkUrl));
        return (
            <DivContainer colClass='container-fluid'>
                <DivContainer colClass='dashboard'>
                    <BlockUi
                        tag='div'
                        blocking={this.state.blocking || this.state.loading}
                        loader={this.loader}
                        rendered={!this.props.embedded}
                    >
                        <CustomMessages id='custom-messages' ref={(el) => (this.messages = el)} rendered={!this.props.embedded} />
                        {this.state.activateDialogVisibile || this.state.deactivateDialogVisibile? (
                            <YesNoDialog
                                visible={this.state.activateDialogVisibile || this.state.deactivateDialogVisibile}
                                header={t('additionalServices.dialogTitle')}
                                name='visible'
                                onChange={(type, x, target) => {
                                    if (target.value === false) {
                                        this.setState({ activateDialogVisibile: false, deactivateDialogVisibile: false })
                                    } else {
                                        if(this.state.activateDialogVisibile === true ){
                                         
                                            this.activateMotorwayPayments()
                                        }
                                       if(this.state.deactivateDialogVisibile === true){
                                            this.dectivateMotorwayPayments()
                                       }
                                    }
                                }}
                                
                                onHide={() => {
                                    this.setState({ activateDialogVisibile: false, deactivateDialogVisibile: false })
                                }}
                                noButtonVariant='button cancel-button white'
                                yesButtonVariant='button save-button blue'
                            >
                                {this.state.activateDialogVisibile === true ? this.renderActivateDialogContent() : this.renderDeactivateDialogContent()}
                            </YesNoDialog>
                        ) : null}
                        {this.state.highwaysAgreementsDialogVisibile && allApprovalsHaveLinkUrl ? (
                            <ApprovalsAcceptationDialog
                                id={`agreement-term-dialog`}
                                ariaCloseIconLabel={this.translate('dialog.closeDialog')}
                                approvals={this.state.approvals}
                                visible={this.state.highwaysAgreementsDialogVisibile}
                                blockUi={this.blockUi}
                                unblockUi={this.unblockUi}
                                showSuccessMessage={this.showSuccessMessage}
                                showErrorMessage={this.showErrorMessage}
                                resizable={true}
                                className='agreement-term-dialog'
                                key={`agreement-term-dialog`}
                                handleReject={() => { }}
                                closable={false}
                                onHide={() => this.handleHybridAgreementDialogClose()}
                            ></ApprovalsAcceptationDialog>) : null}
                          
                        {this.renderAddToTrustedDevicesDialog()}
                        {this.state.loading ? null : (
                            <form onSubmit={this.handleFormSubmit} noValidate>
                                {this.renderDetails()}
                            </form>
                        )}
                    </BlockUi>
                </DivContainer>
            </DivContainer>
        );
    }


getMotorwayHeaderLabel() {
    const { t } = this.props;
    return (
        <>
           {t('additionalServices.motorwayPayments')} <span style={{ fontWeight: 'bold'}}>{t('additionalServices.motorwayPaymentsBracket')}</span>
         <br />
            <span style={{marginLeft:'40px',  color: 'red' , fontWeight: '600'}}>{t('additionalServices.motorwayPaymentsInfo')}</span>
        </>
    );
}

    renderMotorwayPaymentsHeader() {
        const { t } = this.props;
        const headerItems = [
            {
                label: this.getMotorwayHeaderLabel(),
               // label: t('additionalServices.motorwayPayments'),
                type: 'LABEL',
                className: '',
                iconSvg: 'ico_car_highways',
            },
             
        ];
        return this.prepareHeader(headerItems);
    }

    translate(key) {
        const { t } = this.props;
        return t(key);
    }

    handleShowTooltip() {
        this.setState({activateTooltipVisible: true});
    }

    handleHideTooltip() {
        this.setState({activateTooltipVisible: false});
    }

    renderDetails() {
        const { t } = this.props;
      //  const activated = this.authService.getProfile().highwaysEnabled;
        const activated = this.state.enabled;
        const activeLabel = activated === true ? t('additionalServices.highwaysEnabled') : t('additionalServices.highwaysDisabled');
        const contractTerms = this.state.approvalsToDisplay;
        return (
            <React.Fragment>
                <DivContainer colClass='dashboard-link-container dashboard-link-container-profile '>
                    <DivContainer colClass='row'>

                        <DivContainer colClass='col-12'>
                            <Card header={this.renderMotorwayPaymentsHeader()}>
                                <BlockUi
                                    tag='div'
                                    blocking={this.state.profileInfoLoading}
                                    loader={this.loader}
                                    loaderType='small-loader'
                                    horizontal
                                >
                                    <div className='row m-0 additional-services motorways'>

                                        <div className='row col-12 highways-banner'>
                                            <BannerComponent
                                                key={'header-banner'}
                                                label={t('additionalServices.highwaysBannerInfo')}
                                                iconSvg='ico_blue_banner_icon'
                                                iconSide='left'
                                                variant='blue-banner'
                                            ></BannerComponent>
                                        </div>

                                        <div className='row col-4'>
                                            <div className='motorways-info-span '>
                                            <InputTextComponent
                                                id={`motorways-status`}
                                                name='motorwaysStatus'
                                                label={"Status usługi"}
                                                className='p-label'
                                                colClass='col-12'
                                                value={activeLabel}
                                                viewMode={'VIEW'}
                                                showLabel={true}
                                            />
                                            </div>
                                        </div>
                                        <div className='row col-8 motorways-buttons'>
                                            <div className='tooltip-label highways'>
                                                {activated ?
                                                 <ActionButton
                                                 label={t('additionalServices.deactivate')}
                                                 variant='deactivate-button red'
                                                 handleClick={this.handleDeactivateMotorwayPayments}
                                                 disabled={activated === false || this.authService.getProfile().userType === 'STANDARD'}
                                                 rendered = {this.authService.isUserHasAnyPermission('PERMISSION_FULL_ACCESS_ADDITIONAL_SERVICES') && this.authService.getProfile().userType !== 'STANDARD'}
                                             /> : 
                                             <ActionButton
                                             id={'highways-activate-button'}
                                             label={t('additionalServices.activate')}
                                             variant='activate-button white'
                                             handleClick={this.handleActivateMotorwayPayments}
                                             disabled={activated === true || this.authService.getProfile().userType === 'STANDARD'}
                                             eventListeners={[
                                                 {
                                                     eventName: 'mouseenter',
                                                     fnc: this.handleShowTooltip,
                                                     eventElementId: 'highways-activate-button',
                                                 },
                                             ]}
                                             rendered = {this.authService.isUserHasAnyPermission('PERMISSION_FULL_ACCESS_ADDITIONAL_SERVICES') && this.authService.getProfile().userType !== 'STANDARD'}
                                         />

                                         }
                                          <TooltipComponent
                                             id='highways-tooltip-label'
                                             key='highways-tooltip-label'
                                             visible={this.state.activateTooltipVisible}
                                             content={t('additionalServices.tooltip')}
                                             eventListeners={[
                                                 {
                                                     eventName: 'mouseleave',
                                                     fnc: this.handleHideTooltip,
                                                     eventElementId: 'highways-activate-button',
                                                 },
                                                 {
                                                     eventName: 'mouseenter',
                                                     fnc: this.handleShowTooltip,
                                                     eventElementId: 'highways-activate-button',
                                                 },
                                             ]}
                                         />
                                               
                                               
                                            </div>


                                        </div>


                                        <div className='row terms'>
                                            <label id={`contract-terms-label-id`} className=' p-label col-8 p-0'>
                                            {t('additionalServices.terms')}
                                            </label>
                                            {contractTerms?.length > 0
                                                ? contractTerms.map((ct, i) => {
                                                    //let label = t(`${ct.displayName}`)
                                                    let label = ct.displayName;

                                                    return (
                                                        <ActionLink
                                                            label={label}
                                                            variant='contract-terms-highways'
                                                            handleClick={(e) => {
                                                                e.preventDefault();
                                                                this.accountService
                                                                    .getContractTermsFile(ct.fileName)
                                                                    .then((response) => {
                                                                        const displayFileName = ct.displayName + ".pdf";
                                                                        saveAs(response, displayFileName);
                                                                    })
                                                                    .catch(() => {
                                                                        this.showErrorMessage(
                                                                            t('profile.contractTermsFileError')
                                                                        );
                                                                    });
                                                            }}
                                                            key={`highways-terms-button-${i}`}
                                                        />

                                                    )
                                                })
                                                : <div className='motorways-info-span '>
                                                <InputTextComponent
                                                    id={`motorways-status`}
                                                    name='motorwaysStatus'
                                                    className='p-label'
                                                    colClass='col-12'
                                                    value={t('additionalServices.notFoundAcceptedAgreementTerms')}
                                                    viewMode={'VIEW'}
                                                    showLabel={false}
                                                />
                                                </div>}
                                        </div>


                                    </div>

                                </BlockUi>
                            </Card>
                        </DivContainer>
                    </DivContainer>
                </DivContainer>

            </React.Fragment>
        );
    }
    handleActivateMotorwayPayments() {
        const allApprovalsHaveLinkUrl = this.state.approvals?.every(approval =>  approval.contents?.some(el => el.type === "LINK" && el.linkUrl));
        if( this.checkTokenIfAllHybridAgreementNotAccepted() === true){  
            this.setState({ highwaysAgreementsDialogVisibile: true }); 
            if(!allApprovalsHaveLinkUrl){
                  this.showErrorMessage("Błąd podczas pobrania jednego z wymaganych regulaminów. Skontaktuj się z administratorem.")
            }                          
        } else {
            this.setState({ activateDialogVisibile: true });
        }
      
    }
    handleDeactivateMotorwayPayments() {
        this.setState({ deactivateDialogVisibile: true });
    }
    handleActivateMotorwayPaymentsHide(callback) {
        this.setState({ activateDialogVisibile: false, deactivateDialogVisibile: false }, () => {
            if (callback) {
                callback();
            }
        });
    }

    handleOpenDialog(e, type) {
        if (e) {
            e.preventDefault();
        }
        this.setState({ dialogVisibile: true, dialogNotificationType: type });
    }
    handleCloseDialog(id, callback) {
        this.setState({ dialogVisibile: false, twoStageLoginSettingsDialog: false, trustedDevicesDialogVisible: false }, () => {
            if (callback) {
                callback();
            }
        });
    }
}

export default withTranslation()(AdditionalServicesContainer);
